/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "@/src/services/googleAnalyticsService";

type LpFineDrivingBanPartnerMetaProps = {
  partnerFullName: string;
};

const LpFineDrivingBanPartnerMeta = ({ partnerFullName }: LpFineDrivingBanPartnerMetaProps) => {
  const title = partnerFullName ? "Gegen Bußgeldbescheid vorgehen | Legalbird & " + partnerFullName : "Gegen Bußgeldbescheid vorgehen | Legalbird";
  const content = "Reichen Sie als " + partnerFullName + " Kunde Ihren Bußgeldbescheid ein! - Schnell, einfach und sicher!";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={content} />
      <meta name="keywords" content="Verkehrsrecht, Bußgeld, Bußgeldbescheid, Anhörungsbogen, Ordnungswidrigkeit, Fahrverbot" />
      <meta name="robots" content="noindex,nofollow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Reichen Sie als WBS-Rechtsanwälte Kunde Ihren Bußgeldbescheid ein! - Schnell, einfach und sicher!" />
    </Helmet>
  );
};

export default LpFineDrivingBanPartnerMeta;
